import { lazy, useState } from 'react';
import withSuspense from '../../../helpers/withSuspense.jsx';
import Portal from '../../common/Portal.jsx';
import SkeletonGrid from '../../../skeleton_loaders/common/SkeletonGrid.jsx';

const ShowTaskDialog = withSuspense(lazy(() => import('./ShowTaskDialog.jsx'), <SkeletonGrid gridHeight={420} />));

function ShowTaskLink({ label, triggerLabel, programmeId, projectId, identifier, permissions, advancedFeatures }) {
  const [open, setOpen] = useState(false);

  const portalProps = {
    component: ShowTaskDialog,
    programmeId,
    projectId,
    identifier,
    label,
    permissions,
    advancedFeatures,
    onClose: () => setOpen(false)
  };
  return (<>
    {open && <Portal
      {...portalProps}
    />}
    <a style={{cursor: 'pointer', maxWidth: '100%'}} onClick={() => setOpen(true)}>
      {triggerLabel}
    </a>
  </>);
}

export default ShowTaskLink;
